import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import ContactForm from './../contacts/ContactForm';
import Contact from '../../../models/Contact';
import { createNewContact } from '../../../redux/ducks/contacts';
import pageWrapper from '../../containers/MainPage';
import Breadcrumbs from '../../common/Breadcrumbs';

class NewContactPage extends Component {
  handleSubmit = (contact, onSuccess, onFailure) => {
    const { history, onSubmit, returnPath } = this.props;
    const successRedirect = () => {
      onSuccess();
      const nextPage = returnPath ? decodeURIComponent(this.props.returnPath) : '/contacts';
      history.push(nextPage);
    };
    onSubmit(contact, successRedirect, onFailure);
  };

  renderReturnBlock() {
    if (!this.props.returnPath) {
      return null;
    }

    return (
      <div>
        <Link to={decodeURIComponent(this.props.returnPath)}>
          Return to the item you were editing to associate your new contact.
        </Link>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Breadcrumbs segments={[{ label: 'Contacts', linkTo: '/contacts' }, { label: 'Add' }]} />

        <ContactForm
          contact={new Contact()}
          onSubmit={this.handleSubmit}
          returnToItem={this.props.returnPath && this.props.returnPath.length > 0}
        />
      </React.Fragment>
    );
  }
}

NewContactPage.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  returnPath: PropTypes.string,
};

NewContactPage.defaultProps = {
  returnPath: null,
};

function mapStateToProps(state, ownProps) {
  return {
    returnPath: ownProps.match.params.returnPath,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: (contact, onSuccess, onFailure) => {
      dispatch(createNewContact(contact, onSuccess, onFailure));
    },
  };
}

export default pageWrapper(
  connect(mapStateToProps, mapDispatchToProps)(NewContactPage),
  'Add Contact'
);



// WEBPACK FOOTER //
// ./src/components/pages/contacts/NewContactPage.jsx